let Api = {

	"PLANTCATEGORYMAGE_FINDCOMMMAGETREE": "/system/n/plantFindCommMageTree", //种养中心全部品类
    'BIGDAT_BASE_BASEDATA1': "/simple-api/n/wlt/bigdata/base/baseData", // 主要数据指标-设备类型占比图
    'BIGDAT_BASE_FINDLIST1': "/simple-api/n/wlt/bigdata/base/findList", // 大数据查询全部基地列表
    'BIGDAT_BASE_FINDONE1': "/simple-api/n/wlt/bigdata/base/findOne", // 基地详情
    'BASE_BREEDINGSTATISTICS': "/simple-api/n/wlt/bigdata/base/breedingStatistics", // 种养数据统计(万亩)

    'WLT_BIGDATA_TRADE_CHANNELSALE': "/simple-api/n/wlt/bigdata/trade/channelSale", // 年度渠道销售情况 时间轴


    'WLT_BIGDATA_TRADE_INDUSTRY': "/simple-api/n/wlt/bigdata/trade/industry", // 




    
	// "BIGDATA_HOME_OVERVIEW": "/simple-api/n/wlt/bigdata/home/overview", //产业概览
	// "BIGDATA_HOME_VARIETY_LISTCOUNTDATA": "/simple-api/n/wlt/bigdata/home/variety/listCountData", //大数据品种库


	"WLT_BIGDATA_DTJC_CQFBGL": "/simple-api/n/wlt/bigdata/dtjc/cqfbgl", //产区分布概览
    "WLT_BIGDATA_DTJC_XDPFSCJGPAGE": "/simple-api/n/wlt/bigdata/dtjc/xdpfscjgPage", //销地批发市场通货价格更多

	"WLT_BIGDATA_DTJC_ZYCPJJ": "/simple-api/n/wlt/bigdata/dtjc/zycpjj", //产地主要品种均价
    

	"WLT_BIGDATA_DTJC_CDHYJGHQ": "/simple-api/n/wlt/bigdata/dtjc/cdhyjghq", //产地货源价格行情
	"WLT_BIGDATA_DTJC_ZYPZFX": "/simple-api/n/wlt/bigdata/dtjc/zypzfx", //主要品种结构分析
	"WLT_BIGDATA_DTJC_CQCNZS": "/simple-api/n/wlt/bigdata/dtjc/cqcnzs", //产区产能走势
	"WLT_BIGDATA_DTJC_PZJGZS": "/simple-api/n/wlt/bigdata/dtjc/pzjgzs", //产地主要品种价格走势
	
	"WLT_BIGDATA_DTJC_MAPDATA": "/simple-api/n/wlt/bigdata/dtjc/mapData", //地图数据
	"WLT_BIGDATA_DTJC_QRJGQS": "/simple-api/n/wlt/bigdata/dtjc/qrjgqs", //
	
	"WLT_BIGDATA_DTJC_XDPFSCJG": "/simple-api/n/wlt/bigdata/dtjc/xdpfscjg", //销地批发市场通货价格








    
}
module.exports = Api